import React, { FC, Fragment, ReactNode, useEffect } from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { compose } from 'recompose';
import { Trans } from 'react-i18next';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';
import { Divider, List, ListItem, ListItemText, Typography } from '@material-ui/core';

import { isPathMatch } from 'utilities';
import { ILink } from '../../types';

const styles = (theme: Theme) =>
  createStyles({
    search: {
      paddingLeft: 28,
      paddingRight: 28,
    },
    list: {
      width: 300,
      paddingLeft: 16,
      paddingRight: 16,
      paddingBottom: 16,
    },
    listItem: {
      paddingTop: 12,
      paddingBottom: 12,
      marginTop: 8,
      marginBottom: 8,
      borderRadius: 4,
    },
    active: {
      color: theme.palette.primary.main,
    },
  });

interface IProps {
  links: ILink[];
  search: ReactNode;
  onNavigate: () => void;
}

interface IPropsEnhanced extends IProps, WithStyles<typeof styles>, RouteComponentProps {}

const enhancers = compose<IPropsEnhanced, IProps>(withStyles(styles), withRouter);

const Drawer: FC<IPropsEnhanced> = ({ classes, history, links, search, onNavigate }) => {
  useEffect(() => {
    const unlisten = history.listen(() => onNavigate());
    return () => unlisten();
  });

  function renderDrawerListItem(link: ILink) {
    const { i18nKey, component, matchPaths } = link;
    const isActive = isPathMatch(matchPaths, window.location.pathname);

    return (
      <ListItem
        button
        key={i18nKey}
        className={classes.listItem}
        selected={isActive}
        component={component}
      >
        <ListItemText disableTypography>
          <Typography variant="subtitle2">
            <Trans i18nKey={i18nKey} />
          </Typography>
        </ListItemText>
      </ListItem>
    );
  }

  return (
    <Fragment>
      <div className={classes.search}>{search}</div>
      <Divider />
      <List className={classes.list}>{links.map(renderDrawerListItem)}</List>
    </Fragment>
  );
};

export default enhancers(Drawer);
